<template>
  <div class="cell-table" v-loading="loading">
    <el-table
      :data="tableData"
      max-height="100%"
      style="width:calc(100vw - 584px)"
      row-key="id"
      border
      size="medium"
      headerCellClassName="table-hadder"
      cellClassName="unit-set-cell"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      :row-class-name="rowClass"
    >
      <!-- :row-class-name="rowClass" -->
      <el-table-column
        v-for="col of columns"
        :key="col.colId"
        :label="col.colName"
        align="left"
        :fixed="col.fixed"
        :className="col.className"
        :min-width="col.width"
       >
        <template slot-scope="scope">
          <!-- <div>{{scope.column.property}}</div> -->
          <div v-if="col.colId=='index'">{{scope.row.rowName}}</div>
          <div v-else-if="scope.row.rowData[col.colId].isBatch">
            <el-button type="text" :disabled="scope.row.rowData[col.colId].existsFinished" @click="colBatchSetting(scope.row.rowData[col.colId].colId,scope.row.rowData[col.colId].existsFinished)">批量配置</el-button>
          </div>
          <div v-else class="finish-cell flex items-center">
            <div :class="scope.row.rowData[col.colId].isFinished?'finished':'no-finished'">{{scope.row.rowData[col.colId].isFinished?'已配置':'未配置'}}</div>
            <div class="btns ml-2 flex">
              <!-- <el-popover
                placement="bootom"
                width="400"
                trigger="click"
                :disabled="!scope.row.rowData[col.colId].isFinished"
                @show="scope.row.rowData[col.colId].infoVisiable=true"
                @hide="scope.row.rowData[col.colId].infoVisiable=false"
              >  -->
                <!-- <cell-info :id="scope.row.rowData[col.colId].id" :visiable="Boolean(scope.row.rowData[col.colId].infoVisiable)"></cell-info> -->
                <el-button slot="reference" type="text" :disabled="!scope.row.rowData[col.colId].isFinished" @click="toCheck(scope.row.rowData[col.colId].id)">
                  <i class="iconfont icon-jc-blue-open-eyes text-medium"></i>
                </el-button>
              <!-- </el-popover> -->
              
              <el-button type="text" @click="toSetting(scope.row.rowData[col.colId].id)">
                <i class="iconfont icon-jc-edit text-medium"></i>
              </el-button>
            </div>
          </div>
        </template>
      </el-table-column>
       <el-table-column
        label="行批量设置"
        align="left"
        fixed="right"
        min-width="153px"
       >
        <template slot-scope="scope">
          <el-button type="text" v-if="scope.row.rowId" :disabled="scope.row.existsFinished" @click="rowBatchSetting(scope.row)">批量配置</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 单元格设置抽屉 -->
    <div>
      <el-drawer
        :visible.sync="drawerVisiable"
        destroy-on-close
        direction="rtl"
        size="90%"
        :title="drawerTitle"
      >
        <div class="flex h-full" style="background: #F5F5F5; overflow:hidden">
          <div class="left-setting flex-1 mr-4 bg-white box-border overflow-auto left-setting-cell">
          <setting-drawer :drawerType="drawerType" :id="drawId" :indexId="indexNodeId"  @drawreSubmit="drawreSubmit"></setting-drawer>
          </div>
          <template v-if="drawerType == 'cell'"><cell-right-tip/></template>
          <template v-else><cell-right-tip-more /></template>
        </div>
      </el-drawer>
      
    </div>
    <el-dialog
      :visible="infoVisiable"
      width="766px"
      :before-close="handleClose"
    >
      <cell-info :id="checkId"></cell-info>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import CellRightTip from './CellRightTip.vue'
import CellRightTipMore from './CellRightTipMore'
import SettingDrawer from './SettingDrawer.vue'
import {getCellSettingTable} from '@/api/index-statistics'
import CellInfo from'./CellInfo.vue'

export default {
  components:{SettingDrawer, CellRightTip, CellRightTipMore,CellInfo},
  name: 'CellTable',
  data() {
    return {
      columns:[],
      tableData: [],
      drawerVisiable:false,
      drawerType:'',
      drawId:0,
      checkId:0,
      drawerTitle:"单元格数据配置",
      infoVisiable:false,
      loading:false,
    }
  },
  props: {
    reportValue: Number,
    indexNodeId:{
      type:Number,
      default:0
    }
  },
  watch:{
    indexNodeId(){
      this.getTableData()
    }
  },
  mounted(){
    this.getTableData()
  },
  methods: {
    handleClose(){
      this.checkId=0
      this.infoVisiable=false
    },
    rowClass({row}){
      if(row.index == "列批量设置") {
        return 'fixed-row'
      }
    },
    getTableData(){
      this.loading=true
      const index={
        colId:'index',
        colName:'指标',
        className:"first-row",
        fixed:'left',
        width:153,
      }
      getCellSettingTable({indicatorDimensionId:this.indexNodeId}).then(res=>{
        if(res.data.code==0){
           this.columns=[]
          this.columns.push(index)
          res.data.data.columnHeaders.forEach(val=>{
            val.width='153px'
            this.columns.push(val)
          })
          this.tableData=res.data.data.rows
          const data = {rowId:0,rowName:'列批量设置'}
          let rowData={}
          this.columns.forEach(col=>{
              rowData[col.colId]={isBatch:true,colId:col.colId,existsFinished:col.existsFinished}
          })
          data.rowData=rowData
          this.tableData.push(data)
          this.loading=false

        }
      })
    },
    toCheck(cellId){
      this.checkId=cellId
      this.infoVisiable=true
      // console.log(this.checkId,'pp')

    },
    drawreSubmit(){
      this.drawerVisiable=false
      //更新指标树
      this.$parent.getIndexDimensionList()
      this.getTableData()
    },
    toSetting(cellId){
      this.drawerTitle = '指标数值配置'
      this.drawerVisiable=true
      this.drawerType="cell"
      this.drawId=cellId
    },
    rowBatchSetting(row){
      this.drawerTitle = row.rowName + '行批量设置'
      this.drawerVisiable=true
      this.drawerType="row"
      this.drawId=row.rowId
    },
    colBatchSetting(colId){
      this.drawerType="col"
      this.drawId=colId
      const curCol = this.columns.find(item => item.colId == colId)
      this.drawerTitle = curCol.colName+'列批量设置'
      this.drawerVisiable=true
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  height: 0px;
  padding: 16px 16px 0px 16px;
}
::v-deep .el-dialog__body {
  padding: 0px 12px 12px 12px;
}
::v-deep .el-dialog__headerbtn{
  transform: translate(2px,6px);

}
::v-deep .el-drawer__header{
  padding: 11px 16px;
}
.cell-table{
  ::v-deep .unit-set-cell{
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.85);
  }
  ::v-deep .table-hadder, ::v-deep .first-row{
    background-color: #F5F5F5;
  }
  ::v-deep .el-button+.el-button{
    margin-left: 8px;
  }

  .finished{
    color: rgba(0, 0, 0, 0.45);
  
  }
  .no-finished{
    color:#E34152;
  
  }
}
td:hover{
.btns{
      display: block;
    }
}

.finish-cell{
  .btns{
    display: none;
  }

}
.left-setting-cell{
  height: calc(100vh - 48px);
}


</style>
<style lang="scss">
.cell-table{
 .el-table__body {
    // 吸底
    .fixed-row{
      // display: inline-block;
      width: 100%;
      position: sticky;
      bottom: 0;
      // width: calc(100vw - 584px);
      background-color: #fff;
      td{
        background-color: #fff;
        border-bottom: 1px solid #E7E9EB;
        border-right: 1px solid #E7E9EB;
        box-shadow: 0px -1px 0px 0px #e7e9eb;
        &:nth-child(1){
          background-color: #F5F5F5;
          width: 144px;
        }
         &:not(:first-child){
          width: 153px;
        }
      }
    }
  }
}
.select-bg-white{
  .el-input__inner{
    background: #fff;
  }
}

</style>